import RestService from '../services/rest';

export const updateBeetranslates = async () => RestService.putAuthenticated('beetranslate/updateTranslates');

export default { updateBeetranslates };
